<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="110px" size="small">
      <el-form-item label="卡号:" prop="cardNumber">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.cardNumber" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="手机号:" prop="userPhone">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.userPhone" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="会员姓名:" prop="childName">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.childName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="卡名称:" prop="cardName">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.cardName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="金额:">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.totalPay" placeholder=""></el-input>
      </el-form-item>
      <!-- <el-form-item label="卡类型:" >
        <el-input  readonly="true" style="width: 240px;"  v-model="cardInfo.cardName" placeholder=""></el-input>
      </el-form-item> -->
      <el-form-item label="正价课时:" v-if="cardInfo.consumeType != 1">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.totalClassCount" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="赠送课时:" v-if="cardInfo.consumeType != 1">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.giveClassCount" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="剩余正价课时:" v-if="cardInfo.consumeType != 1">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.remTotalClassCount" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="剩余赠送课时:" v-if="cardInfo.consumeType != 1">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.remGiveClassCount" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="时间:" prop="" v-if="cardInfo.consumeType == 1">
        <el-date-picker  readonly="true" v-model="cardInfo.value1" value-format="yyyy-MM-dd" type="daterange" range-separator="-"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width: 270px">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="频率:" prop="" v-if="cardInfo.consumeType == 1">
        <div style="display: flex;">
          <el-input-number readonly="true" v-model="cardInfo.frequency" style="width: 200px" :min="0" disabled></el-input-number>
            (课/周)
        </div>
          </el-form-item>
      <el-form-item label="有效期:" v-if="cardInfo.consumeType != 1">
        <el-input readonly="true" style="width: 240px" v-model="cardInfo.cardEndTime" placeholder=""></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "CardInfo",
  props: {
    cardInfo: Object,
  },
  data() {
    return {};
  },
  created() {
    this.initData();
  },
  methods: {
    initData() { },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/CardInfo.vue